var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 5.46875V19.5312C25 20.8252 23.9502 21.875 22.6562 21.875H2.34375C1.0498 21.875 0 20.8252 0 19.5312V5.46875C0 4.1748 1.0498 3.125 2.34375 3.125H6.64062L7.24121 1.51855C7.58301 0.605469 8.45703 0 9.43359 0H15.5615C16.5381 0 17.4121 0.605469 17.7539 1.51855L18.3594 3.125H22.6562C23.9502 3.125 25 4.1748 25 5.46875ZM18.3594 12.5C18.3594 9.26758 15.7324 6.64062 12.5 6.64062C9.26758 6.64062 6.64062 9.26758 6.64062 12.5C6.64062 15.7324 9.26758 18.3594 12.5 18.3594C15.7324 18.3594 18.3594 15.7324 18.3594 12.5ZM16.7969 12.5C16.7969 14.8682 14.8682 16.7969 12.5 16.7969C10.1318 16.7969 8.20312 14.8682 8.20312 12.5C8.20312 10.1318 10.1318 8.20312 12.5 8.20312C14.8682 8.20312 16.7969 10.1318 16.7969 12.5Z",
    fill: "#3E8181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/IcCamera.0be555e55b43416df4c1027fad01f688.svg";
export { ForwardRef as ReactComponent };